<!-- Applies to whichever of the goal's two messages is showing (the Threshold tab holds their text),
     so the spacing doesn't jump when the goal flips from not-met to met. -->
<div class="field">
  <span class="field__label">Message padding</span>
  <pdq-dropdown
    [formControl]="goal.controls.appearance.controls.messagePadding"
    [options]="paddingOptions"
    [useOverlay]="true"
    fullWidth="true"></pdq-dropdown>
  <span class="field__hint">Applies to both the "goal not met" and "goal met" messages</span>
</div>

@if (
  goal.controls.offer.controls.type.value === 'freeShipping' ||
  goal.controls.offer.controls.type.value === 'orderDiscount' ||
  goal.controls.offer.controls.type.value === 'product'
) {
  <div class="field">
    <span class="field__label">Icon</span>
    <pdq-iconpicker
      [presetIconUrls]="presetIconUrls"
      [iconUrl]="goal.controls.appearance.controls.iconUrl.value"
      [customIconUrl]="goal.controls.appearance.controls.customIconUrl.value"
      (iconUrlChange)="onIconUrlChange($event)"
      (uploadCustomRequested)="onUploadCustomIcon()"
      (removeCustomRequested)="onRemoveCustomIcon()"></pdq-iconpicker>
    @if (iconUploadError) {
      <span class="threshold-error">{{ iconUploadError }}</span>
    }
  </div>

  @if (barType.value === 'sequential' && pillsEnabled.value) {
    <div class="field">
      <span class="field__label">Pill Text</span>
      <pdq-input [formControl]="goal.controls.appearance.controls.pillText" placeholder="Enter Text.."></pdq-input>
      <span class="field__hint">Use the dynamic field {{ '{threshold}' }}</span>
    </div>
  }

  @if (barType.value !== 'sequential') {
    <pdq-checkbox
      [formControl]="goal.controls.appearance.controls.showLabelsInProgressBar"
      label="Show labels in progress bar"
      labelSize="small"></pdq-checkbox>

    @if (goal.controls.appearance.controls.showLabelsInProgressBar.value) {
      <div class="field">
        <div class="pill-source-header">
          <span class="field__label">1st Label</span>
          @if (pillsEnabled.value) {
            @if (goal.controls.appearance.controls.pillSource.value === 'first') {
              <span class="pill-source pill-source--active">Used as pill</span>
            } @else {
              <span class="pill-source" (click)="setPillSource('first')">Use as pill</span>
            }
          }
        </div>
        <pdq-input [formControl]="goal.controls.appearance.controls.firstLabel" placeholder="{threshold}"></pdq-input>
        <span class="field__hint">Use the dynamic field {{ '{threshold}' }}</span>
      </div>
      <div class="field">
        <span class="field__label">Position</span>
        <pdq-dropdown
          [formControl]="goal.controls.appearance.controls.firstLabelPosition"
          [options]="labelPositionOptions"
          fullWidth="true"></pdq-dropdown>
      </div>

      <div class="field">
        <div class="pill-source-header">
          <span class="field__label">2nd Label</span>
          @if (pillsEnabled.value) {
            @if (goal.controls.appearance.controls.pillSource.value === 'second') {
              <span class="pill-source pill-source--active">Used as pill</span>
            } @else {
              <span class="pill-source" (click)="setPillSource('second')">Use as pill</span>
            }
          }
        </div>
        <pdq-input
          [formControl]="goal.controls.appearance.controls.secondLabel"
          placeholder="Label example"></pdq-input>
        <span class="field__hint">Leave empty to hide</span>
      </div>
      <div class="field">
        <span class="field__label">Position</span>
        <pdq-dropdown
          [formControl]="goal.controls.appearance.controls.secondLabelPosition"
          [options]="labelPositionOptions"
          [disabled]="!goal.controls.appearance.controls.secondLabel.value"
          fullWidth="true"></pdq-dropdown>
      </div>

      <div class="field">
        <span class="field__label">Label Size</span>
        <pdq-input-arrows
          [formControl]="goal.controls.appearance.controls.labelSize"
          [min]="12"
          widthSize="fullwidth"></pdq-input-arrows>
      </div>
    }
  }
}

@if (
  (goal.controls.offer.controls.type.value === 'orderDiscount' &&
    !goal.controls.offer.controls.orderDiscount.controls.autoApply.value) ||
  goal.controls.offer.controls.type.value === 'product'
) {
  <pdq-card variant="popover" color="white">
    <div class="card" [formGroup]="goal.controls.appearance.controls.applySection">
      <div class="card__header">
        <pdq-heading element="h5">"Apply" Section</pdq-heading>
        <pdq-button
          class="collapse-chevron"
          [class.collapse-chevron--open]="!applySectionCollapsed"
          icon="arrow_down"
          variant="ghost"
          plain="true"
          size="large"
          iconColor="var(--on-surface-default)"
          (onClick)="toggleApplySectionCollapsed()"></pdq-button>
      </div>
      @if (!applySectionCollapsed) {
        <pdq-divider></pdq-divider>
        <div class="card__content">
          <span class="subsection__title">Background</span>
          <div class="field-row">
            <div class="field">
              <span class="field__label">Color</span>
              <pdq-input-color
                [formControl]="
                  goal.controls.appearance.controls.applySection.controls.background.controls.color
                "></pdq-input-color>
            </div>
            <div class="field">
              <span class="field__label">Padding</span>
              <pdq-dropdown
                [formControl]="goal.controls.appearance.controls.applySection.controls.background.controls.padding"
                [options]="paddingOptions"
                fullWidth="true"></pdq-dropdown>
            </div>
          </div>
          <div class="field">
            <span class="field__label">Corner Radius</span>
            <pdq-input-arrows
              [formControl]="goal.controls.appearance.controls.applySection.controls.background.controls.cornerRadius"
              widthSize="fullwidth"
              [min]="0"
              [required]="false"
              placeholder="0"></pdq-input-arrows>
          </div>
          <div class="field">
            <pdq-checkbox
              [formControl]="
                goal.controls.appearance.controls.applySection.controls.background.controls.border.controls.enabled
              "
              label="Border"
              labelSize="small"></pdq-checkbox>
          </div>
          @if (
            goal.controls.appearance.controls.applySection.controls.background.controls.border.controls.enabled.value
          ) {
            <div class="field-row">
              <div class="field">
                <span class="field__label">Border width</span>
                <pdq-input-arrows
                  [formControl]="
                    goal.controls.appearance.controls.applySection.controls.background.controls.border.controls.width
                  "
                  widthSize="fullwidth"
                  [min]="0"
                  [required]="false"
                  placeholder="0"></pdq-input-arrows>
              </div>
              <div class="field">
                <span class="field__label">Border color</span>
                <pdq-input-color
                  [formControl]="
                    goal.controls.appearance.controls.applySection.controls.background.controls.border.controls.color
                  "></pdq-input-color>
              </div>
            </div>
          }

          <span class="subsection__title">Texts</span>
          <div class="field">
            <span class="field__label">Title</span>
            <pdq-input
              [formControl]="goal.controls.appearance.controls.applySection.controls.texts.controls.title"
              placeholder="Here's your gift"></pdq-input>
          </div>
          <div class="field">
            <span class="field__label">Subtitle</span>
            <pdq-input
              [formControl]="goal.controls.appearance.controls.applySection.controls.texts.controls.subtitle"
              placeholder="Click the button below to add it to your shopping cart"></pdq-input>
          </div>

          @if (goal.controls.offer.controls.type.value === 'orderDiscount') {
            <div class="field">
              <div class="message-header">
                <span class="field__label message-header__label">Order discount message</span>
                <pdq-button
                  icon="preview_eye"
                  variant="ghost"
                  plain="true"
                  size="medium"
                  iconColor="var(--on-surface-default)"></pdq-button>
              </div>
              <rich-textarea
                [initialContent]="
                  goal.controls.appearance.controls.applySection.controls.texts.controls.orderDiscountMessage.value
                "
                (contentChange)="onOrderDiscountMessageChange($event)"
                [enableLinkInsert]="true"
                placeholder="{discount} off your order!"></rich-textarea>
              <span class="field__hint">Use the dynamic field {{ '{discount}' }}</span>
            </div>
          }

          <div class="field-row">
            <div class="field">
              <span class="field__label">Text color</span>
              <pdq-input-color
                [formControl]="
                  goal.controls.appearance.controls.applySection.controls.texts.controls.textColor
                "></pdq-input-color>
            </div>
            <div class="field">
              <span class="field__label">Font size</span>
              <pdq-input-arrows
                [formControl]="goal.controls.appearance.controls.applySection.controls.texts.controls.fontSize"
                widthSize="fullwidth"
                [min]="0"
                [required]="false"
                placeholder="0"></pdq-input-arrows>
            </div>
          </div>

          <span class="subsection__title">Button</span>
          <div class="field">
            <span class="field__label">Label</span>
            <pdq-input
              [formControl]="goal.controls.appearance.controls.applySection.controls.button.controls.label"
              placeholder="I want this!"></pdq-input>
          </div>
          <div class="field">
            <div class="field__label-row">
              <span class="field__label">Background Color</span>
              @if (applyButtonDesign.backgroundColorOverridden()) {
                <pdq-link
                  label="Reset to global color"
                  size="small"
                  (onClick)="
                    resetToGlobal(
                      goal.controls.appearance.controls.applySection.controls.button.controls.backgroundColor
                    )
                  "></pdq-link>
              }
            </div>
            <pdq-input-color [formControl]="applyButtonDesign.displayBackgroundColor"></pdq-input-color>
          </div>
          <div class="field">
            <div class="field__label-row">
              <span class="field__label">Text Color</span>
              @if (applyButtonDesign.textColorOverridden()) {
                <pdq-link
                  label="Reset to global color"
                  size="small"
                  (onClick)="
                    resetToGlobal(goal.controls.appearance.controls.applySection.controls.button.controls.textColor)
                  "></pdq-link>
              }
            </div>
            <pdq-input-color [formControl]="applyButtonDesign.displayTextColor"></pdq-input-color>
          </div>
          <div class="field">
            <div class="field__label-row">
              <span class="field__label">Hover Color</span>
              @if (applyButtonDesign.hoverColorOverridden()) {
                <pdq-link
                  label="Reset to global color"
                  size="small"
                  (onClick)="
                    resetToGlobal(goal.controls.appearance.controls.applySection.controls.button.controls.hoverColor)
                  "></pdq-link>
              }
            </div>
            <pdq-input-color [formControl]="applyButtonDesign.displayHoverColor"></pdq-input-color>
          </div>
          <div class="field">
            <div class="field__label-row">
              <span class="field__label">Corner Radius</span>
              @if (applyButtonDesign.cornerRadiusOverridden()) {
                <pdq-link
                  label="Reset to global number"
                  size="small"
                  (onClick)="
                    resetToGlobal(goal.controls.appearance.controls.applySection.controls.button.controls.cornerRadius)
                  "></pdq-link>
              }
            </div>
            <pdq-input-arrows
              [formControl]="applyButtonDesign.displayCornerRadius"
              widthSize="fullwidth"
              [min]="0"
              [required]="false"
              placeholder="0"></pdq-input-arrows>
          </div>

          @if (goal.controls.offer.controls.type.value === 'product') {
            <span class="subsection__title">Image</span>
            <div class="field">
              <span class="field__label">Fit</span>
              <pdq-dropdown
                [formControl]="goal.controls.appearance.controls.applySection.controls.image.controls.fit"
                [options]="imageFitOptions"
                fullWidth="true"></pdq-dropdown>
            </div>
            <div class="field">
              <span class="field__label">Border width</span>
              <pdq-input-arrows
                [formControl]="goal.controls.appearance.controls.applySection.controls.image.controls.borderWidth"
                widthSize="fullwidth"
                [min]="0"
                [required]="false"
                placeholder="0"></pdq-input-arrows>
            </div>
            <div class="field">
              <span class="field__label">Corner Radius</span>
              <pdq-input-arrows
                [formControl]="goal.controls.appearance.controls.applySection.controls.image.controls.cornerRadius"
                widthSize="fullwidth"
                [min]="0"
                [required]="false"
                placeholder="0"></pdq-input-arrows>
            </div>
            <div class="field">
              <span class="field__label">Inner Padding</span>
              <pdq-input-arrows
                [formControl]="goal.controls.appearance.controls.applySection.controls.image.controls.innerPadding"
                widthSize="fullwidth"
                [min]="0"
                [required]="false"
                placeholder="0"></pdq-input-arrows>
            </div>
          }
        </div>
      }
    </div>
  </pdq-card>
}
